import { Alert, RadioCheckedIcon, RadioUncheckedIcon } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const OptionCard = ({ selected = false, onClick, alertType, alertMessage, children }) => (
  <Styles.Card selected={selected} onClick={onClick}>
    <Styles.Row>
      {selected ? <RadioCheckedIcon /> : <RadioUncheckedIcon />}
      <Styles.Info>{children}</Styles.Info>
    </Styles.Row>
    {selected && (
      <Styles.AlertSlot>
        <Alert type={alertType} size="s">
          {alertMessage}
        </Alert>
      </Styles.AlertSlot>
    )}
  </Styles.Card>
)

export default OptionCard
